import './AnchorLink.css';

export default function AnchorLink({ children, link, primary }) {
  const extraClassName = primary ? ' primary' : ''
  return (
    <a href={`#${link}`} className={`button-text anchor-link ${extraClassName}`}>{children}</a>
  );
}
